import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SelectionAssigned from './SelectionAssigned';
import SelectionNotAssigned from './SelectionNotAssigned';
import * as Styled from './styles';
import SuccessfullyEntered from './SuccessfullyEntered';
import EventStarted from './EventStarted';
import Terms from '../Terms';
import { getDayOfWeek, getFormattedTime } from '../../helpers/dateTimeHelpers';
import { useSportConfig } from '../../hooks/useSportConfig';

const Entered = ({
    title,
    eventName,
    prize,
    hasEventStarted,
    entry,
    excludeFromBetting,
    startDate,
    TermsLink,
    bettingEnabled,
    allocationDate
}) => {
    const { config } = useSportConfig();
    const name = get(entry, 'name', null);
    const excludeBetting = hasEventStarted || excludeFromBetting;
    const hasEventNotStarted = !hasEventStarted;

    const weekday = startDate ? getDayOfWeek(startDate) : null;
    const time = startDate ? getFormattedTime(startDate) : null;

    const { selectionNoun } = config.labels;
    const { eventNoun } = config.labels;

    return (
        <>
            <Styled.EnteredWrapper>
                <Styled.EnteredContentWrapper>
                    <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
                    {hasEventStarted ? (
                        <EventStarted eventName={eventName} />
                    ) : (
                        <SuccessfullyEntered title={title} />
                    )}
                    {name ? (
                        <>
                            <SelectionAssigned
                                title={title}
                                selection={entry}
                                excludeFromBetting={excludeBetting}
                                bettingEnabled={bettingEnabled}
                            />
                        </>
                    ) : (
                        <SelectionNotAssigned
                            eventName={eventName}
                            allocationDate={allocationDate}
                        />
                    )}
                    {name && hasEventStarted && (
                        <Terms
                            showTermsText={false}
                            margin="16px 0 0 0"
                            TermsLink={TermsLink}
                        />
                    )}
                    {hasEventNotStarted && (
                        <>
                            <Styled.PrizeText>
                                If your {selectionNoun} wins the{' '}
                                <Styled.Highlighted>
                                    {time} {eventName} {eventNoun}
                                </Styled.Highlighted>{' '}
                                {weekday ? `on ${weekday}` : ''}, you will be
                                entered into a{' '}
                                <Styled.Highlighted>
                                    Prize Draw
                                </Styled.Highlighted>{' '}
                                to win{' '}
                                <Styled.Highlighted>
                                    {prize}!
                                </Styled.Highlighted>
                            </Styled.PrizeText>
                            <Terms
                                margin="0"
                                startDate={startDate}
                                TermsLink={TermsLink}
                            />
                        </>
                    )}
                </Styled.EnteredContentWrapper>
            </Styled.EnteredWrapper>
        </>
    );
};

Entered.defaultProps = {
    startDate: undefined,
    entry: {}
};

Entered.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    hasEventStarted: PropTypes.bool.isRequired,
    entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        metaData: PropTypes.shape({})
    }),
    excludeFromBetting: PropTypes.bool.isRequired,
    startDate: PropTypes.string,
    TermsLink: PropTypes.func.isRequired,
    bettingEnabled: PropTypes.bool.isRequired,
    allocationDate: PropTypes.string.isRequired
};

export default Entered;
